


import React from 'react';
import styles from "../../assets/CommonScss/DeleteConfirmModalLogout.module.scss";
import DeleteIcon from '../../assets/images/delete.png';

const DeleteConfirmModalLogout = ({
  isOpen,
  onConfirm,
  onCancel,
  title = '',
  heading = '',
  content = ''
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalBox}>
        <img src={DeleteIcon} alt="Delete Confirm" className={styles.image} />
        <h2 className={styles.title}>{title}</h2>
        <h2 className={styles.title}>{heading}</h2>
        <p className={styles.modalMessage}>{content}</p>
        <div className={styles.buttons}>
          <button className={styles.cancelBtn} onClick={onCancel}>Cancel</button>
          <button className={styles.confirmBtn} onClick={onConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModalLogout;

